module.exports = __webpack_public_path__ + "fonts/Calibre-Regular.b63c62e5.woff2";